import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useUser } from "../../hooks/User";
import { LoginContainer } from "./styled-auth";

interface AuthPageProps {
  children: React.ReactChild
}

export const AuthPage = ({ children }: AuthPageProps) => {
  const navigate = useNavigate();
  const isLogged = useUser().getDataByAttributeName("isLogged");

  useEffect(() => {
    if (isLogged) { navigate("/"); }
  }, [isLogged, navigate]);

  return <LoginContainer>{children}</LoginContainer>;
}